import { ADD_HP_PLUGIN, UPDATE_HP_PLUGIN, DELETE_HP_PLUGIN } from '.';
import { SET_INITIAL_STATE } from '../../reducer';

const initialState = [];
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_INITIAL_STATE:
      return action.payload.hosted_payments_plugins;
    case ADD_HP_PLUGIN:
      return [...state, action.device];
    case UPDATE_HP_PLUGIN:
      return state.map(device =>
        device.id === action.device.id ? action.device : device
      );
    case DELETE_HP_PLUGIN:
      return state.filter(device => device.id !== action.id);
    default:
      return state;
  }
};
